import React, { Component } from 'react';

import Button from '@material-ui/core/Button';
import Typography from '@material-ui/core/Typography';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import { withStyles } from '@material-ui/core/styles';

import TaskItem from './TaskItem';

const styles = theme => ({
  root: {

  },
  button: {
    margin: theme.spacing.unit,
  },
  white: {
    color: '#fff',
  },
  description: {
    minWidth: '300px',
  },
  table: {
    minWidth: "700px",
  },
});

class TaskTable extends Component {
  constructor(props) {
    super(props);

    this.state = {
      showItem: undefined,
      selectedItem: undefined,
    }
  }

  handleEditOpen = () => {
    this.setState({showItem: "edit"});
  };

  handleAddOpen = () => {
    this.setState({showItem: "add"});
  };

  handleClose = () => {
    this.setState({
      showItem: undefined,
      selectedItem: undefined,
    });
  };

  render() {
    const { classes, type, task } = this.props;
    const { showItem, selectedItem } = this.state;
    let items = [];

    if (type.toLowerCase() === "labor" && task.labor) {
      items = task.labor;
    } else if (task.materials) {
      items = task.materials;
    }

    return(
      <div className={classes.root}>
        <TaskItem
          showItem={showItem}
          projectTask={task}
          item={selectedItem}
          type={type}
          handleClose={this.handleClose}
        />
        <Table className={classes.table}>
          <TableHead>
            <TableRow>
              <TableCell className={classes.white} padding="dense" variant="head">Description</TableCell>
              <TableCell className={classes.white} padding="dense" variant="head" numeric>Qty</TableCell>
              <TableCell className={classes.white} padding="dense" variant="head" numeric>Rate</TableCell>
              <TableCell className={classes.white} padding="dense" variant="head" numeric>Markup</TableCell>
              <TableCell className={classes.white} padding="dense" variant="head" numeric>Total</TableCell>
              <TableCell className={classes.white} padding="none" variant="head" />
            </TableRow>
          </TableHead>
          <TableBody>
            {items.map((item) => {
              return(
                <TableRow
                  hover
                  key={item.id}
                  style={{cursor: 'pointer'}}
                >
                  <TableCell
                    className={classes.description}
                    padding="dense"
                    variant="body"
                    onClick={() => this.setState({showItem: "edit", selectedItem: item})}
                    >
                    <Typography className={classes.white}>
                      {item.description}
                    </Typography>
                  </TableCell>
                  <TableCell
                    padding="dense"
                    variant="body"
                    numeric
                    onClick={() => this.setState({showItem: "edit", selectedItem: item})}
                    >
                    <Typography className={classes.white}>{item.quantity}</Typography>
                  </TableCell>
                  <TableCell
                    padding="dense"
                    variant="body"
                    numeric
                    onClick={() => this.setState({showItem: "edit", selectedItem: item})}
                    >
                    <Typography className={classes.white}>${item.rate.toFixed(2)}</Typography>
                  </TableCell>
                  <TableCell
                    padding="dense"
                    variant="body"
                    numeric
                    onClick={() => this.setState({showItem: "edit", selectedItem: item})}
                    >
                    <Typography className={classes.white}>0</Typography>
                  </TableCell>
                  <TableCell
                    padding="dense"
                    variant="body"
                    numeric
                    onClick={() => this.setState({showItem: "edit", selectedItem: item})}
                    >
                    <Typography className={classes.white}>${item.total.toFixed(2)}</Typography>
                  </TableCell>
                </TableRow>
              );
            })}
          </TableBody>
        </Table>
        <Button
          color="default"
          className={classes.button}
          onClick={this.handleAddOpen}
        >
          Add Item
        </Button>
      </div>
    );
  }
}

export default withStyles(styles)(TaskTable);



// WEBPACK FOOTER //
// ./src/components/admin/Jobs/Tasks/TaskTable.jsx